import '../../shared/preferences/preferences'
import '../../vendors/intlTelInput/intlTelInput'

import Webview from '../../../../assets/javascripts/web_view'
import { inputFilterOnlyNumbers } from '../../core/utils/inputFilter.js'

const $doc = $(document)
const $mail_lightbox = $('#change-mail')
const $pass_lightbox = $('#change-password')
const $image_lightbox = $('#change-image')
const $newsletter_lightbox = $('#check-newsletter')
const $mail_form = $mail_lightbox.find('.formz')
const $pass_form = $pass_lightbox.find('.formz')
const $image_form = $image_lightbox.find('.formz')
const $newsletter_form = $newsletter_lightbox.find('.formz')
const $mail_submit = $mail_form.find('.btn-primary')
const $pass_submit = $pass_form.find('.btn-primary')
const $image_submit = $image_form.find('.btn-primary')
const $newsletter_submit = $newsletter_form.find('.btn-primary')
const $new_email = $('#new-email')
const $new_email_repeat = $('#new-email-repeat')
const $old_pass = $('#old-pass')
const $new_pass = $('#iberostar_api_user_password')
const $new_pass_repeat = $('#iberostar_api_user_password_repeat')
const $new_image = $('#iberostar_api_user_image')
const $personal_data = $('.accordion-block.personal-data')
const $notifications = $('.accordion-block.notifications')
const $country = $('#country')
const $postal_code = $('#postal-code')
const $presented_phone = $('#presented-phone')

export function init() {
  const $edit_user_page = $('.edit-user-page')
  const logged_from_call_center =
    $('.form-horizontal.formz#personal-data').data('logged-from-call-center') ||
    $('.edit-user-content').data('logged-from-call-center')

  if (!$edit_user_page.length) return

  if (Webview.getIsEmbedded()) {
    loadEmbeddedContent()
  }

  if ($edit_user_page.length && logged_from_call_center) {
    disablePersonalDataFormIfLoginCallCenter()
  }

  $('.edit-lightbox').find('form').parsley()

  $('.edit-user-fancybox').fancybox({
    clickSlide: false,
    touch: false,
  })

  $('.newsletter-fancybox').fancybox({
    clickSlide: false,
    touch: false,
  })

  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  const event = isIE11 ? 'change' : 'input'

  $personal_data.add($notifications).on(event, function () {
    enablePersonalDataForm($(this))
  })

  $doc.on(event, '#personal-data input', function (e) {
    $(this).addClass('edited')
  })

  $personal_data.add($notifications).on('submit', function (e) {
    window.onbeforeunload = function () {
      // blank function do nothing
    }
    if (!$(this).find('form').parsley().isValid()) {
      e.preventDefault()
      window.onbeforeunload = function () {
        return 'Did you save your stuff?'
      }
    } else {
      $(this).find('form').find('.action').find('.clear-form').addClass('disabled')
    }
  })

  $personal_data.add($notifications).on('click', '.clear-form', function (e) {
    e.preventDefault()
    const $this = $(this)

    if ($this.hasClass('disabled')) return

    $this.closest('form').trigger('reset')

    $this.addClass('disabled')
    $this.closest('.accordion-block').removeClass('edited').find('.btn-primary').prop('disabled', true)
    $('input.edited').removeClass('edited')

    if (!$personal_data.hasClass('edited') && !$notifications.hasClass('edited')) {
      window.onbeforeunload = function () {
        // blank function do nothing
      }
    }
  })

  $($new_email)
    .add($new_email_repeat)
    .on('keyup', function () {
      if ($new_email.val() && $new_email_repeat.val() && $mail_submit.is(':disabled')) {
        $mail_submit.prop('disabled', false)
      }
    })

  $($old_pass)
    .add($new_pass)
    .add($new_pass_repeat)
    .on('keyup', function () {
      if ($old_pass.val() && $new_pass.val() && $new_pass_repeat.val() && $pass_submit.is(':disabled')) {
        $pass_submit.prop('disabled', false)
      }
    })

  $($new_image).on('change', function () {
    if ($new_image.val()) {
      if ($image_submit.is(':disabled')) {
        $image_submit.prop('disabled', false)
      }
    } else {
      $image_submit.prop('disabled', 'disabled')
    }
  })

  $presented_phone.intlTelInput()

  // Init formz on phone field
  FORMZ.required_fields.init($presented_phone)
  // Filter input to allow only numbers
  $presented_phone && inputFilterOnlyNumbers({ textBox: $presented_phone.get(0) })

  $presented_phone.on('countrychange', function (e, countryData) {
    if ($presented_phone.val() !== '') {
      enablePersonalDataForm($personal_data)
    }
  })

  if (typeof google === 'undefined') loadGoogleMapsScript()

  $country.on('change', function () {
    checkGooglePostalCode()
  })

  $postal_code.on('blur', function () {
    checkGooglePostalCode()
  })

  toggleAllCheckboxes()
}

function loadGoogleMapsScript() {
  const lang =
    document.documentElement.getAttribute('data-js-lang') ||
    document.documentElement.getAttribute('data-js-lang') ||
    $('html').attr('xml:lang') ||
    'en'
  const script = document.createElement('script')
  const url = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&language=${lang}`
  script.type = 'text/javascript'
  script.src = url
  document.body.appendChild(script)
}

function checkGooglePostalCode() {
  if ($country.val() === '' || $postal_code.val() === '') return

  const geocoder = new google.maps.Geocoder()
  let city = ''
  const $city_input = $('#city')

  geocoder.geocode(
    {
      componentRestrictions: {
        country: $country.val(),
        postalCode: $postal_code.val(),
      },
    },
    function (results, status) {
      if (status === 'OK') {
        const cities = results[0].postcode_localities
        if (cities) {
          $city_input.parent().find('select').remove()
          // turn city into a dropdown if necessary
          const $select = $(document.createElement('select'))

          $select.on('change', function () {
            $city_input.val($(this).val())
          })

          $.each(cities, function (index, locality) {
            const $option = $(document.createElement('option'))
            $option.html(locality)
            $option.attr('value', locality)
            // if(city == locality) {
            //   $option.attr('selected','selected');
            // }
            $select.append($option)
            $select.trigger('change')
          })
          $select.attr('id', 'city-select')
          $city_input.hide()
          $city_input.parent().append($select)
        } else {
          const address_components = results[0].address_components
          $.each(address_components, function (index, component) {
            const types = component.types
            $.each(types, function (index, type) {
              if (type == 'locality') {
                city = component.long_name
              }
            })
          })
          $city_input.parent().find('select').remove()
          if (!$city_input.is(':visible')) $city_input.show()
          $city_input.val(city)
        }
      } else {
        $city_input.parent().find('select').remove()
        $city_input.val('')
        if (!$city_input.is(':visible')) $city_input.show()
      }
    }
  )
}

function enablePersonalDataForm($el) {
  if (!$el.hasClass('edited')) {
    $el.find('.action').find('.clear-form').removeClass('disabled')
    $el.find('.action').find('.btn-primary').prop('disabled', false)
    $el.addClass('edited')
    window.onbeforeunload = function () {
      return 'Did you save your stuff?'
    }
  }
}

function disablePersonalDataFormIfLoginCallCenter() {
  $('a.connect-btn').remove()
  $('a.edit-user-fancybox').remove()
  $('a.newsletter-fancybox').remove()
  $('.simple_form .action button.btn-primary').addClass('disabled')

  $('form input, form select').attr('disabled', 'disabled')
  $('form input, form select').attr('readonly', 'readonly')

  $('a.preferences-lightbox-link').remove()
}

$doc.on('click', '.accordion-title', function (e) {
  e.preventDefault()
  $(this).closest('.accordion-block').toggleClass('opened')
})

function toggleAllCheckboxes() {
  const btnMainCheckbox = document.querySelector('.js-main-checkbox')
  const boxSpamList = document.querySelectorAll('.sibiling')
  const smsAuthorizationBtn = document.querySelector('.js-sms-authorization-checkbox')
  const smsNoAcceptInput = document.querySelector('.js-no-accept-sms-input')

  function setCheckboxes(checked) {
    boxSpamList.forEach(boxSpam => {
      boxSpam.checked = checked
    })

    if (smsAuthorizationBtn) {
      smsAuthorizationBtn.checked = !checked
    }
  }

  if (btnMainCheckbox) {
    btnMainCheckbox.addEventListener('click', function () {
      setCheckboxes(btnMainCheckbox.checked)
    })
  }

  boxSpamList.forEach(boxSpam => {
    boxSpam.addEventListener('click', function () {
      if (!boxSpam.checked && btnMainCheckbox) {
        btnMainCheckbox.checked = false
      }
    })
  })

  if (smsAuthorizationBtn) {
    smsAuthorizationBtn.addEventListener('click', function () {
      if (smsNoAcceptInput) {
        smsNoAcceptInput.checked = !smsAuthorizationBtn.checked
      }
      checkFatherCheckbox()
    })
  }

  if (smsNoAcceptInput) {
    smsNoAcceptInput.addEventListener('click', function () {
      if (smsAuthorizationBtn) {
        smsAuthorizationBtn.checked = !smsNoAcceptInput.checked
      }
    })
  }
}

/**
 * Function to check the father checkbox
 */
function checkFatherCheckbox() {
  const btnMainCheckbox = document.querySelector('.js-main-checkbox')
  const childCheckboxes = document.querySelectorAll('.sibiling')
  if (btnMainCheckbox && childCheckboxes.length > 0) {
    const allChecked = Array.from(childCheckboxes).every(checkbox => checkbox.checked)
    btnMainCheckbox.checked = allChecked
  } else if (btnMainCheckbox) {
    btnMainCheckbox.checked = false
  }
}

//If you checked all children input automatically the father is checked too PY0400-350
$('.sibiling').on('change', function () {
  const btnMainCheckbox = document.querySelector('.js-main-checkbox')

  if (btnMainCheckbox && $('.sibiling').length > 0) {
    if ($('.sibiling:checked').length == $('.sibiling').length) {
      btnMainCheckbox.checked = true
    }
  }
})

$doc.on('click', '.cancel-user-edit, .updated-lightbox .btn-primary', function (e) {
  e.preventDefault()
  parent.jQuery.fancybox.getInstance().close()
})

$doc.on('click', '#personal-info-submit', function (e) {
  if ($presented_phone.val() !== '') {
    const phonePrefix = $('.selected-dial-code').text()
    const phoneNumber = $('#presented-phone').val()
    const phoneValue = `${phonePrefix} ${phoneNumber}`

    $('#phone').val(phoneValue)
  }

  const $user_name = $('#iberostar_api_user_first_name')
  /* Actualizamos el nombre del usuario en redis para que se muestre actualizado en el menú */
  if ($user_name.hasClass('edited') && IB.browsing_sessions !== undefined) {
    IB.browsing_sessions.store('name', $user_name.val())
  }
})

$doc.on('click', '.edit-user-page .connect-btn', function (e) {
  e.preventDefault()
  const $this = $(this)
  const connected = $this.hasClass('connected')
  const src = connected ? $this.data('disconnect-src') : $this.attr('href')

  $.fancybox.open({
    src,
    opts: {
      smallBtn: !connected,
      toolbar: false,
      clickOutside: connected ? false : 'close',
      clickSlide: connected ? false : 'close',
      touch: connected ? false : 'close',
    },
  })

  if (connected) {
    window.location.replace($this.data('disconnect-url'))
  }
})

function loadEmbeddedContent() {
  const contentToHide = {
    header: document.querySelector('.mobile-header'),
    footer: document.querySelector('.block-layer'),
    socialMediaLinking: document.querySelector('.my-account-element').lastElementChild,
  }

  Object.entries(contentToHide).forEach(([id, content]) => {
    content && content.classList.add('hidden')
  })

  //Opens all accordion blocks
  document.querySelectorAll('.edit-user-content .accordion-block').forEach(accordion => {
    accordion.classList.add('opened')
  })

  //Style settings
  document.querySelector('.bg-color-with-fastbooking').classList.remove('mb-5')
}

init()
